module.exports = __webpack_public_path__ + "static/media/cha-logo.12f7c3f1.png";